// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://dev-backend.givtapp.net",
  apiUrlEU: "https://dev-backend.givtapp.net",
  apiUrlUS: "https://dev-backend.givt.app",
  oldDashboardUrl: "https://givtdashboarddebug.azurewebsites.net",
  oldDashboardUrlEU: "https://clouddebug.givtapp.net",
  oldDashboardUrlUS: "https://clouddebug.givt.app",
  wePayApi: "https://debug-wepay-api.givt.app",
  wePayAppId: "537744",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
